<div class="collapsed-timer" [class.collapsed-timer--stopped]="!timer.active">
	<button
		class="collapsed-timer__button ellipsis"
		[class.tooltip]="timer?.matter?.name"
		[attr.data-tooltip]="timer?.matter?.name"
		[matTooltip]="null"
		(click)="expandModal()"
	>
		<span class="collapsed-timer__button__info ellipsis">{{ timer?.matter?.name || '-' }}</span>
	</button>
	<div class="collapsed-timer__time-wrapper">
		<p>{{ timer.active && duration_ms ? (duration_ms | inputHours) : timer.duration }}</p>
		@if (!timer.active) {
			<mat-icon class="icon-button" (click)="startCounter()" matSuffix>play_arrow</mat-icon>
		}
		@if (timer.active) {
			<mat-icon class="icon-button icon-button--pause-active" (click)="stopCounter()" matSuffix> pause </mat-icon>
		}
	</div>
</div>
